<template>
    <div ref="createHOTKEY" class="modal fade" id="confirm_hotkey_modal" tabindex="-1" role="dialog"
        aria-labelledby="createhotkeyLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4 class="">Create Hot Key</h4>
                    <div class="modal-header border-0 m-0 p-0 justify-content-end">
                        <button class="btn-close" id="close-hotkey-btn" data-bs-dismiss="modal" aria-label="Close"
                            @click="cancelHotkey">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                </div>
                <Form @submit="confirm_change" :validation-schema="schema">
                    <div class="modal-body confirm">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">
                                            Current Supplier
                                            <span class="text-danger">*</span>
                                        </label>
                                        <Field name="supplier_id" v-model="formData.supplier_id">
                                            <vue-select v-bind="field" :options="supplierOptions"
                                                v-model="formData.supplier_id" placeholder="Select....."
                                                @select="myChangeEvent($event)" autocomplete="off" autocorrect="off"
                                                autocapitalize="off" spellcheck="false" />
                                        </Field>
                                        <ErrorMessage name="supplier_id" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label d-flex w-100">CED <span
                                                class="text-danger">*</span> </label>
                                        <div class="icon-form">
                                            <Field name="contract_end_date" v-model="formData.contract_end_date"
                                                v-slot="{ field }">
                                                <date-time-picker
                                                    v-model="formData.contract_end_date"
                                                    text-input
                                                    format="dd/MM/yyyy"
                                                    auto-apply
                                                    :enable-time-picker="false"
                                                    :disabled=false
                                                    :clearable=true
                                                />
                                            </Field>
                                            <ErrorMessage name="contract_end_date" class="text-danger" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">NIC</label>
                                        <Field as="select" name="nic" class="form-select" v-model="formData.nic">
                                            <option value="">-----Select-----</option>
                                            <option v-for="res in YESNOOptions" :key="res" :value="res">
                                                {{ res }}
                                            </option>
                                        </Field>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">COT</label>
                                        <Field as="select" name="cot" class="form-select" v-model="formData.cot">
                                            <option value="">-----Select-----</option>
                                            <option v-for="res in YESNOOptions" :key="res" :value="res">
                                                {{ res }}
                                            </option>
                                        </Field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">COT Date</label>
                                        <div class="icon-form">
                                            <date-time-picker
                                                v-model="formData.cot_date"
                                                text-input
                                                format="dd/MM/yyyy"
                                                auto-apply
                                                :enable-time-picker="false"
                                                :disabled=false
                                                :clearable=true
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">Sales Responsible</label>
                                        <Field as="select" name="referred_by" class="form-select"
                                            v-model="formData.sales_responsible">
                                            <option value="">-----Select-----</option>
                                            <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                                {{ res.name }}
                                            </option>
                                        </Field>
                                        <ErrorMessage name="sales_responsible" class="text-danger" />
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                    <div class="col-md-12">
                        <div class="form-wrap mb-3">
                            <label class="col-form-label">Comment </label>
                            <textarea class="form-control" rows="4" v-model="formData.comment"></textarea>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button type="submit" class="btn btn-primary confirm-btn me-2">
                            Confirm
                        </button>
                        <button type="button" class="btn btn-outline-secondary cancel-btn" @click="cancelHotkey">
                            Cancel
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, toRefs } from 'vue';
import { Form, ErrorMessage, Field } from 'vee-validate';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { changeFormate } from '@/util';
import * as Yup from "yup";

export default {
    components: { Form, Field, ErrorMessage },
    props: {
        formData: {
            type: Object,
            default: false
        },
        supplierOptions: {
            type: Object,
            default: false
        },
        oppData: {
            type: Object,
            default: false
        },
        saleResponsibleOptions: {
            type: Array,
            default: () => []
        }
    },
    emits: ['created'],
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        // Ensure formData is reactive
        const { formData, supplierOptions, oppData } = toRefs(props);
        const createHOTKEY = ref();

        const schema = Yup.object().shape({
            supplier_id: Yup.string()
                .required("Current Supplier is required"),
            contract_end_date: Yup.string()
                .required("CED  is required"),

        });

        const confirm_change = async () => {
            const data = {
                supplier_id: formData.value.supplier_id,
                contract_end_date: changeFormate(formData.value.contract_end_date),
                nic: formData.value.nic,
                cot: formData.value.cot,
                cot_date: changeFormate(formData.value.cot_date),
                comment: formData.value.comment,
                reason: formData.value.reason,
                sales_responsible: formData.value.sales_responsible,
                referred_by: formData.value.referred_by, // <-- Add this
            };

            const form = {
                oppId: formData.value.id,
                payload: data,
            };

            const response = await store.dispatch("opportunity/createHotKey", form);

            if (response?.status) {
                document.getElementById("close-hotkey-btn").click();
                emit('created', response?.data);

                const url = router.resolve({
                    path: `/crm/meter-opportunities-edit/${response?.data?.opportunity_id}`
                }).href;
                window.open(url, "_blank");
            }
        };


        const cancelHotkey = async () => {
            formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
            formData.value.supplier_id = oppData.value.supplier_id;
            formData.value.comment = oppData.value.comment;
            document.getElementById("close-hotkey-btn").click();
        };

        const myChangeEvent = (event) => {
            if (event.id === 'null') {
                // supplier_id.value = null;
                formData.value.supplier_id = null;

            }
            else {
                // supplier_id.value = formData.value.supplier_id;
            }
        }

        const clickOutside = () => {
            formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
            formData.value.supplier_id = oppData.value.supplier_id;
            formData.value.comment = oppData.value.comment;
        };


        onMounted(() => {
            if (createHOTKEY.value) {
                createHOTKEY.value.addEventListener("hidden.bs.modal", clickOutside);
            }
        });
        return {
            formData,
            supplierOptions,
            confirm_change,
            cancelHotkey,
            myChangeEvent,
            schema,
            createHOTKEY,
            dateFormat: "dd/MM/yyyy",
            YESNOOptions: ["YES", "NO"],

        };
    }
};
</script>
